import { Dialog, Grid, styled } from '@mui/material';
import React, { useEffect } from 'react';

export interface AllergensModalProps {
    open: boolean;
    onClose: any;
    allergensList: [number, string][];
}

function AllergensModal(props: AllergensModalProps) {

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));
    useEffect(() => {
        console.log(props.allergensList);
    }, [])

    return (
        <BootstrapDialog onClose={props.onClose} open={props.open}>
            <div className='allergensModal'>

                <div className='allergensModal-title'>
                    Allergeni
                </div>
                {props.allergensList.map(i =>

                    <Grid container spacing={2}>
                        <Grid item className='allergensModal-list'>
                            {i[0]}
                        </Grid>
                        <Grid item className='allergensModal-list'>
                            {i[1]}
                        </Grid>
                    </Grid>
                )}

            </div>
        </BootstrapDialog>
    );
}

export default AllergensModal;